import {filterArrayNull, filterArrayUndefined} from '@coolcolduk/util';
import {ModuleTopic} from '@cp/model';
import {env} from '../../config/env';

export interface MapModuleTopicToTopicStringOptions {
  spacer?: string;
  isFull?: boolean;
}

/**
 * Map a module topic to a topic string
 * @param moduleTopic - The module topic to map
 * @param options - The options for the mapping
 * @returns The topic string
 */
export default function mapModuleTopicToTopicString(
  moduleTopic: ModuleTopic,
  options: MapModuleTopicToTopicStringOptions = {},
): string {
  const {spacer = env.topic.spacer, isFull = false} = options;

  const arr = [moduleTopic.category, moduleTopic.topic, ...(isFull ? [moduleTopic.detail] : [])];

  return filterArrayNull(filterArrayUndefined(arr)).join(spacer);
}
